import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import { api } from "../../services/api";
import TributacaoCard from "./TributacaoCard";


const setText = (value) => value || '—';

const NcmResult = (props) => {
  const result = props.result;
  const type = props.type;

  const [selected, setSelected] = useState(0);
  const [loading, setLoading] = useState(false);
  const [cClassTrib, setcClassTrib] = useState(null);
  const [listcClassTrib, setListcClassTrib] = useState([]);
  const [assessment, setAssessment] = useState("");
  const [ncmData, setNcmData] = useState(null);
  const [ncmLinks, setNcmLinks] = useState([]);

  const [isDescExpanded, setIsDescExpanded] = useState(false);
  const [showDescButton, setShowDescButton] = useState(false);
  const descContentRef = useRef(null);

  const [description, setDescription] = useState("");
  const [code, setCode] = useState("");

  const [isListExpanded, setIsListExpanded] = useState(false);
  const listContentRef = useRef(null);

  async function handleResult(codigo) {
    if (type !== "NCM") return
    setSelected(codigo);
    setLoading(true);
    setcClassTrib(null);
    try {
      const { data, status } = await api.get(`reforma/bens/ncm`, {
        params: {
          ncm: codigo
        }
      });
      if (status !== 200) {
        throw new Error('Erro ao buscar cClassTrib');
      }
      setListcClassTrib(data?.cclass_trib || [])
      setcClassTrib(data?.cclass_trib?.[0]?.[0] ?? (data?.cclass_trib?.[0] || null));

      setAssessment(data?.status_busca || "");
    }
    catch (error) {
      setcClassTrib(null);
      setAssessment("");
    }
    finally {
      setLoading(false);
    }
  }

  const findSiscomexNCM = async (code) => {
    try {
      const { data } = await api.get(`siscomex/consulta/ncm`, {
        params: { ncm: code }
      });
      setNcmData(data?.result_ncm);
      setNcmLinks(data?.links);
      setCode(data?.result_ncm?.Codigo);
    }
    catch (err) {
      setNcmData(null);
      setNcmLinks([]);
      setCode(null);
    }

  }

  useLayoutEffect(() => {
    if (descContentRef.current && descContentRef.current.scrollHeight > 60) {
      setShowDescButton(true);
    } else {
      setShowDescButton(false);
    }
  }, [ncmData?.Descricao]);

  useEffect(() => {
    if (result?.ncm && type !== "NCM") {
      findSiscomexNCM(result.ncm);
    }
  }, [result?.ncm, type, props]);

  useEffect(() => {
    if (props?.codigo && props?.canSearch) {
      props.setCanSearch(false);
      handleResult(props.codigo);
    }
  }, [props.codigo, props.canSearch, props.setCanSearch]);

  useEffect(() => {
    if (type !== "NCM") {
      setListcClassTrib(typeof result?.cclass_trib !== "string" ? (result?.cclass_trib || []) : [])
      setcClassTrib(result?.cclass_trib?.[0]?.[0] ?? (result?.cclass_trib?.[0] || null));
      setAssessment(result?.status_busca)
    }
    if (type === "NCM") {
      setNcmData(result?.result_ncm);
      setNcmLinks(result?.links)
    }
    if (ncmData?.Codigo) {
      setSelected(ncmData.Codigo);
      setDescription(ncmData?.Descricao)
    }
  }, [ncmData, result]);



  return (
    <div className="w-full max-w-7xl mx-auto py-8 ">
      <section className="grid gap-8 lg:grid-cols-[22rem_1fr]">
        <div>
          <div class="bg-white rounded-2xl shadow-soft border border-gray-200 p-5 mb-6 font-mono!">
            <div class="flex items-center justify-between">
              <h2 class="text-lg font-semibold tracking-tight">Detalhes do NCM</h2>
              <span class="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-emerald-50 text-emerald-700 border border-emerald-200">
                Ativo
              </span>
            </div>
            <div class="mt-4 grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-4">
              <div>
                <div class="text-xs text-gray-500">Código NCM</div>
                <div class="text-lg font-bold font-mono text-gray-900">{setText(cClassTrib?.ncm || code)}</div>
              </div>
              <div>
                <div class="text-xs text-gray-500">Tipo de ato</div>
                <p className="text-gray-900 text-sm font-medium">
                  {ncmData?.Tipo_Ato_Ini || ncmData?.Numero_Ato_Ini ?
                    `${setText(ncmData?.Tipo_Ato_Ini)} ${setText(ncmData?.Numero_Ato_Ini)}/${setText(ncmData?.Ano_Ato_Ini)}`
                    : '—'
                  }
                </p>
              </div>
            </div>
            <div className="mt-2">
              <div class="text-xs text-gray-500">Descrição</div>
              <div className="relative text-gray-900">
                <p
                  ref={descContentRef}
                  className={`transition-all text-sm font-medium`}
                  dangerouslySetInnerHTML={{ __html: setText(description) }}
                ></p>
              </div>
            </div>
          </div>
          <div class="bg-white rounded-2xl shadow-soft border border-gray-200 p-5 mb-6">
            <h2 class="text-lg font-semibold tracking-tight mb-4">Hierarquia de classificação</h2>
            <div class="space-y-3">

              <div class="rounded-xl border border-blue-200 bg-blue-50 p-3">
                <div class="text-xs font-medium text-blue-800">Posição 2</div>
                <div class="text-sm text-blue-900" dangerouslySetInnerHTML={{ __html: setText(ncmData?.["Descricao posicao 2"]) }}>
                </div>
              </div>

              <div class="rounded-xl border border-emerald-200 bg-emerald-50 p-3">
                <div class="text-xs font-medium text-emerald-800">Posição 4</div>
                <div class="text-sm text-emerald-900" dangerouslySetInnerHTML={{ __html: setText(ncmData?.["Descricao posicao 4"]) }}></div>
              </div>

              <div class="rounded-xl border border-orange-200 bg-orange-50 p-3">
                <div class="text-xs font-medium text-orange-800">Posição 5</div>
                <div class="text-sm text-orange-900" dangerouslySetInnerHTML={{ __html: setText(ncmData?.["Descricao posicao 5"]) }}></div>
              </div>
            </div>
          </div>
          <aside className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 h-max sticky top-4 ">

            <h3 className="text-lg font-bold mb-4">NCM correspondentes</h3>
            {
              selected ?
                <button
                  className={`w-full mb-2 text-left rounded-lg border p-3 transition-all duration-200 border-yellow-300 bg-yellow-50`}
                >
                  <div className="flex justify-between items-center">
                    <span className={`font-mono text-sm font-bold text-yellow-800`}>
                      {code || cClassTrib?.ncm}
                    </span>
                    <span className="text-xs bg-yellow-200 text-yellow-800 px-2 py-0.5 rounded">Atual</span>
                  </div>
                  <p className={`text-xs mt-1 text-yellow-700text-gray-600`}
                    dangerouslySetInnerHTML={{ __html: setText(description) }}></p>
                </button> : null
            }
            <div
              ref={listContentRef}
              className={`space-y-2 overflow-y-auto transition-all ${isListExpanded ? 'max-h-none' : 'max-h-[28rem]'} scroll`}
            >
              {result?.ncm_correspondentes?.filter(item => selected !== item?.codigo)
                ?.map((item, index) => (
                  <button
                    key={index}
                    onClick={() => {
                      handleResult(item?.codigo);
                      setDescription(item?.descricao);
                      setCode(item?.codigo);
                    }}
                    className={`w-full text-left rounded-lg border p-3 transition-all duration-200
                ${selected === item?.codigo
                        ? "border-yellow-300 bg-yellow-50"
                        : "border-gray-200 bg-gray-50 hover:bg-gray-100"
                      }`}
                  >
                    <div className="flex justify-between items-center">
                      <span className={`font-mono text-sm ${selected === item?.codigo ? 'font-bold text-yellow-800' : 'font-medium text-gray-800'}`}>
                        {item?.codigo}
                      </span>
                      {selected === item?.codigo && (
                        <span className="text-xs bg-yellow-200 text-yellow-800 px-2 py-0.5 rounded">Atual</span>
                      )}
                    </div>
                    <p className={`text-xs mt-1 ${selected === item?.codigo ? 'text-yellow-700' : 'text-gray-600'}`}
                      dangerouslySetInnerHTML={{ __html: item?.descricao }}></p>
                  </button>
                ))}
            </div>
            {(result?.ncm_correspondentes?.length > 5) && (
              <button
                onClick={() => setIsListExpanded(!isListExpanded)}
                className="w-full mt-3 text-blue-600 hover:text-blue-800 text-sm font-medium"
              >
                <i className={`fa-solid ${isListExpanded ? 'fa-chevron-up' : 'fa-chevron-down'} mr-1`}></i>
                {isListExpanded ? 'Ver menos' : 'Ver todos'}
              </button>
            )}
          </aside>
        </div>
        <div>
          <div>
            {loading ? (
              <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 flex items-center justify-center min-h-[400px]">
                <p className="text-gray-500">Carregando detalhes tributários...</p>
              </div>
            ) : (
              <TributacaoCard assessment={assessment} cClassTrib={cClassTrib} ncmLinks={ncmLinks} listcClassTrib={listcClassTrib} setcClassTrib={setcClassTrib} />
            )}
          </div>
        </div>
      </section>
    </div>
  );
};

export default NcmResult;